<div mat-dialog-title class="d-flex justify-content-between align-items-center">
  <h2 class="p-0 m-0">
    {{'incident.dialogs.reflex_sheet' | translate}}
  </h2>
  <mat-icon mat-dialog-close>close</mat-icon>
</div>
<div mat-dialog-content>
  <div [innerHtml]="reflexSheet"></div>
</div>
